import type { CSSProperties } from 'react';
import { duration, radius, space } from '../scale.js';
import { wedgeRole } from './wedgeRoles.js';

/* Measured AppearanceSettings tile geometry, outside the shared spacing scale. */
const TILE_MIN_HEIGHT = 110;
const TILE_PADDING_X = 14;
const TILE_GAP = 10;
const TILE_BORDER = 1.5;

export function wedgeThemeChoiceStyle(selected: boolean): CSSProperties {
  return {
    background: wedgeRole(selected ? 'accentTint' : 'surface'),
    border: `${TILE_BORDER}px solid ${wedgeRole(selected ? 'accent' : 'separator')}`,
    borderRadius: radius.xl,
    padding: `${space[4]}px ${TILE_PADDING_X}px`,
    fontFamily: wedgeRole('font'), cursor: 'pointer',
    display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: TILE_GAP,
    textAlign: 'left', minHeight: TILE_MIN_HEIGHT,
    transition: `all ${duration.press}ms ${wedgeRole('ease')}`,
  };
}

const tile = '[data-rv-button][data-rv-appearance="wedge-theme-choice"]';
export const WEDGE_THEME_CHOICE_CSS = `
${tile}:focus-visible { outline: 2px solid ${wedgeRole('accent')}; outline-offset: 2px; }
@media (prefers-reduced-motion: reduce) { ${tile} { transition: none !important; } }
`;
